import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75bc7ef6"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-theme"];
const _hoisted_2 = { class: "lg:flex-1 min-h-full" };
const _hoisted_3 = { class: "AppLogo absolute lg:static z-1 top-16 font-screamer font-bold text-20 leading-screamer" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "flex-1" };
const _hoisted_6 = { class: "flex justify-end items-center gap-32" };
import { computed, defineAsyncComponent } from "vue";
import { boldify } from "@/core/i18n";
import Viewport from "@/store/modules/Viewport";
import { useAppState, useStoryContext, useStoryState } from "@/services/Composition";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppHeader',
    props: {
        theme: { default: "dark" }
    },
    setup(__props) {
        const props = __props;
        const LazyStoryTimeline = defineAsyncComponent(() => import("../Story/StoryTimeline.vue"));
        const { state, send } = useAppState();
        const { state: storyState, send: sendStory } = useStoryState();
        const isStory = computed(() => state.value.matches("story"));
        const isAbout = computed(() => state.value.matches("home.home.about"));
        const isCredits = computed(() => state.value.matches("end"));
        const isDIT = computed(() => state.value.matches("dit"));
        const canDIT = computed(() => (isStory.value ? storyState : state).value.can("OPEN_DIT"));
        const openDIT = () => (isStory.value ? sendStory : send)("OPEN_DIT");
        const isStoryMenuOpen = useStoryContext("isMenuOpen");
        const canStoryMenu = computed(() => isStory.value && (storyState.value.can("OPEN_MENU") || storyState.value.can("CLOSE_MENU")));
        const openStoryMenu = () => sendStory("OPEN_MENU");
        const showBrand = computed(() => {
            if (Viewport.isDesktop) {
                return isStory.value || isDIT.value || isAbout.value || isCredits.value;
            }
            return isStoryMenuOpen.value;
        });
        const showNav = computed(() => !(isAbout.value || isCredits.value || isDIT.value));
        return (_ctx, _cache) => {
            const _component_UIIcon = _resolveComponent("UIIcon");
            const _component_UIBtn = _resolveComponent("UIBtn");
            const _directive_sound = _resolveDirective("sound");
            return (_openBlock(), _createBlock(_Transition, {
                name: "fade",
                appear: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("header", {
                        class: "AppHeader flex items-center gap-6 h-56 lg:h-40 py-16 lg:py-0",
                        "data-theme": _ctx.theme
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_Transition, {
                                duration: { enter: 833, leave: 0 },
                                appear: ""
                            }, {
                                default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("span", _hoisted_3, [
                                        _createElementVNode("span", {
                                            class: "flex flex-col items-start leading-08",
                                            innerHTML: _unref(boldify)(_ctx.$t('header.logo'))
                                        }, null, 8, _hoisted_4)
                                    ], 512), [
                                        [_vShow, showBrand.value]
                                    ])
                                ]),
                                _: 1
                            }),
                            (canStoryMenu.value && !_unref(Viewport).isDesktop)
                                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "flex justify-center items-center -ml-8 text-32",
                                    onClick: openStoryMenu
                                }, [
                                    _createVNode(_component_UIIcon, { name: "menu" })
                                ])), [
                                    [
                                        _directive_sound,
                                        void 0,
                                        void 0,
                                        { click: true }
                                    ]
                                ])
                                : _createCommentVNode("", true)
                        ]),
                        (isStory.value)
                            ? (_openBlock(), _createBlock(_unref(LazyStoryTimeline), { key: 0 }))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("nav", _hoisted_6, [
                                (canStoryMenu.value && _unref(Viewport).isDesktop)
                                    ? (_openBlock(), _createBlock(_component_UIBtn, {
                                        key: 0,
                                        appear: false,
                                        onClick: openStoryMenu
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("header.nav.menu")), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _withDirectives((_openBlock(), _createBlock(_component_UIBtn, {
                                    appear: false,
                                    disabled: !canDIT.value,
                                    onClick: openDIT
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("header.nav.dit")), 1)
                                    ]),
                                    _: 1
                                }, 8, ["disabled"])), [
                                    [
                                        _directive_sound,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                    ]
                                ])
                            ], 512), [
                                [_vShow, showNav.value]
                            ])
                        ])
                    ], 8, _hoisted_1)
                ]),
                _: 1
            }));
        };
    }
});
